import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { SxProps, Theme } from '@mui/material/styles';

import { Link } from 'common/components/Link';
import { Logo } from 'common/components/Logo';

import { MainNavigation } from '../MainNavigation';

const appBarStyle: SxProps<Theme> = {
    top: 'var(--top-offset, 0px)',
    bgcolor: 'background.default',
    boxShadow: 'none',
    borderBottom: 1,
    borderColor: 'divider',
    height: (theme) => theme.mixins.toolbar.height,
    '& .MuiToolbar-regular': {
        height: (theme) => theme.mixins.toolbar.height,
    },
    '& .logoLink': {
        height: '100%',
        py: 2,
        px: 0,
        '& img': {
            maxHeight: 48,
            display: 'block',
        },
    },
};

interface IProps {
    navigation?: React.ReactNode;
    showNavigation?: boolean;
}

export const AppBar = ({ navigation, showNavigation = true }: IProps) => (
    <>
        <MuiAppBar id="mainNav" sx={appBarStyle}>
            <Toolbar>
                <Link className="logoLink" to="HOME">
                    <Logo />
                </Link>

                {showNavigation && (navigation || <MainNavigation />)}
            </Toolbar>
        </MuiAppBar>
        {/* Spacer to account for the app bar height */}
        <Box sx={{ height: (theme) => theme.mixins.toolbar.height }} />
    </>
);
